// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rowQuadrant {

  height: 88%;

}

.leftQuadrant {
  /* width: 75%; */
  width: 100%;
  height: 85%;
  display: flex;
}

.columnLeft {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.columnMap {
  height: 60%;
  /* display: none; */
}

.columnAlertMin {
  height: 5%;
  position: absolute;
  bottom: 0;
  width: 20%;
  right: 0;
}

.columnAlert {
  height: 40% !important;
  position: absolute !important;
  bottom: 0;
  width: 80% !important;
  right: 0;
}

.columnAlert1 {
  height: 88%;
  position: absolute;
  bottom: 0%;
  width: 35%;
  right: 0%;
}

.menuAlertTitle {
  height: 5%;
  /* max-height: 30px; */
  cursor: pointer;
}

.menuAlertTablaMin {
  height: 85%;
  position: relative;
  display: none;
  width: 100%;
}

.menuAlertTitleMin {
  height: 100%;
  max-height: 30px;
  cursor: pointer;
}

.imgCardTitleMin {
  position: absolute;
  height: 80%;
  width: 4%;
  left: 92%;
  display: flex;
  max-height: 25px;
}

.imgCardTitleMin:hover {
  background-color: #f1f1f127;
}

.cardTitleAlert {
  /* background: linear-gradient( #4d0000, #8e0000); */
  /* background: linear-gradient( #6c0101, #8e0000); */
  /* background:var(--red-alert); */
  background: var(--third-color);
  /* background-color: rgba(13, 13, 13, 0.45); */
}

.cardTitleAlertWhite {
  /* background: linear-gradient( #4d0000, #8e0000); */
  /* background: linear-gradient( #6c0101, #8e0000); */
  background: linear-gradient(#6c0101f6, #8e0000d8);
}

.menuAlertTabla {
  /* padding: 1%; */
  /* height: 95%; */
  height: calc(100% - 30px);
  position: relative;
  display: block;
  width: 100%;
}

.TableHeader {
  height: 10%;
  position: relative;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: rgba(13, 13, 13, 0.45);
  /* background: var(--third-color); */
  max-height: 25px;
}

.TableBody {
  height: 82%;
  position: relative;
  display: block;
  width: 100%;
  justify-content: center;
  align-items: center;
  /* background-color: rgba(82, 82, 82, 0.347); */
  /* background-color: rgba(70, 0, 0, 0.34); */
  /* background-color: rgba(255, 179, 179, 0.5); */
  overflow-y: scroll;
  scrollbar-width: thin;

}

.headerCell:hover {
  cursor: pointer;
}

.headerCell {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 15%;
  /* border-left: 1px solid white; */
  color: white;
  /* font-weight: bold; */
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}

.txtHeaderCell {
  /* font-weight: unset; */
  font-size: var(--font-size-xSmall);
  letter-spacing: 1px;
  color: var(--white-color) !important;

}

.imgCardTitle {
  position: absolute;
  height: 10%;
  width: 10%;
  left: 90%;
  display: flex;
  max-height: 25px;
}

.imgContent {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mapboxgl-control-container {
  display: none !important;
}

.expandLogo {
  position: relative;
  height: 80%;
}

.expandLogo:hover {
  height: 90%;
  cursor: pointer;
}

/***************************MODAL***********************************/
.ReactModal__Overlay {
  background-color: #0d0d0de5 !important;
  z-index: 200;
}

.ReactModal__Content {
  padding: unset !important;
  border: 1px solid #f0f8ff91 !important;
  border-radius: 10px !important;
  background-color: var(--white-color) !important;
  /* background-color: #11121be3 !important; */
}

/************************************************************************ ESTILOS DE SCROLL BAR**************************************************/
/********************   chrome  *********************/
/* Estilo del scrollbar */
.TableBody::-webkit-scrollbar {
  width: 10px;
  /* Ancho del scrollbar */
}

/* Estilo del thumb (la barra deslizante) */
.TableBody::-webkit-scrollbar-thumb {
  background-color: #ffffff;
  /* Color del thumb */
  border-radius: 5px;
  /* Borde redondeado del thumb */
}

/* Estilo del thumb al pasar el cursor sobre él */
.TableBody::-webkit-scrollbar-thumb:hover {
  background-color: #ffffff;
  /* Color del thumb al pasar el cursor */
}

/* Estilo de la pista (el área donde se desplaza el thumb) */
.TableBody::-webkit-scrollbar-track {
  background-color: #f1f1f100;
  /* Color de la pista */
}

/********************   firefox  *********************/
/* Estilo del thumb (la barra deslizante) */
.TableBody::-moz-scrollbar-thumb {
  background-color: #d51111;
  /* Color del thumb */
  border-radius: 5px;
  /* Borde redondeado del thumb */
}

/* Estilo del thumb al pasar el cursor sobre él */
.TableBody::-moz-scrollbar-thumb:hover {
  background-color: #e20e0e;
  /* Color del thumb al pasar el cursor */
}

/* Estilo de la pista (el área donde se desplaza el thumb) */
.TableBody::-moz-scrollbar-track {
  background-color: #f1f1f1;
  /* Color de la pista */
}

.map-container {
  width: 100%;
  height: 100%;
}

/************************Horizontal Movil*************************/
@media (min-width: 500px) and (max-width: 900px) {}

/************************Movil*************************/
@media (max-width: 500px) {
  .menuAlertTabla {
    width: 300%;
  }

  .card .menuAlertTabla {
    width: 100%;
  }

  .menuAlertTitle {
    width: 300%;
  }

  .imgCardTitleMin.expand {
    left: 292%;
  }

  .imgCardTitleMin.log {
    left: 280% !important;
  }

  .cont-menu-eventos {
    width: 120% !important;
  }

  .card .cont-menu-eventos {
    width: 40% !important;
  }

  .card .imgCardTitleMin.log {
    left: 80% !important;
  }

  .card .imgCardTitleMin.expand {
    left: 92%;
  }

  .compactSelector {
    height: 100% !important;
  }

  .labelSelector {
    top: 0% !important;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/styles/LeftQuadrant.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;;AAEb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,SAAS;EACT,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;EACpD,oDAAoD;EACpD,iCAAiC;EACjC,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,oDAAoD;EACpD,oDAAoD;EACpD,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;EAC/C,4CAA4C;EAC5C,gDAAgD;EAChD,kBAAkB;EAClB,qBAAqB;;AAEvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,YAAY;EACZ,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,mBAAmB;EACnB,oCAAoC;;AAEtC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,oEAAoE;AACpE;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,8BAA8B;EAC9B,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA,iJAAiJ;AACjJ,qDAAqD;AACrD,yBAAyB;AACzB;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,iDAAiD;AACjD;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA,4DAA4D;AAC5D;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,sDAAsD;AACtD,2CAA2C;AAC3C;EACE,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,iDAAiD;AACjD;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,kEAAkE;AAClE,kDAAkD;;AAElD,uDAAuD;AACvD;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;AAEF","sourcesContent":[".rowQuadrant {\r\n\r\n  height: 88%;\r\n\r\n}\r\n\r\n.leftQuadrant {\r\n  /* width: 75%; */\r\n  width: 100%;\r\n  height: 85%;\r\n  display: flex;\r\n}\r\n\r\n.columnLeft {\r\n  position: relative;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.columnMap {\r\n  height: 60%;\r\n  /* display: none; */\r\n}\r\n\r\n.columnAlertMin {\r\n  height: 5%;\r\n  position: absolute;\r\n  bottom: 0;\r\n  width: 20%;\r\n  right: 0;\r\n}\r\n\r\n.columnAlert {\r\n  height: 40% !important;\r\n  position: absolute !important;\r\n  bottom: 0;\r\n  width: 80% !important;\r\n  right: 0;\r\n}\r\n\r\n.columnAlert1 {\r\n  height: 88%;\r\n  position: absolute;\r\n  bottom: 0%;\r\n  width: 35%;\r\n  right: 0%;\r\n}\r\n\r\n.menuAlertTitle {\r\n  height: 5%;\r\n  /* max-height: 30px; */\r\n  cursor: pointer;\r\n}\r\n\r\n.menuAlertTablaMin {\r\n  height: 85%;\r\n  position: relative;\r\n  display: none;\r\n  width: 100%;\r\n}\r\n\r\n.menuAlertTitleMin {\r\n  height: 100%;\r\n  max-height: 30px;\r\n  cursor: pointer;\r\n}\r\n\r\n.imgCardTitleMin {\r\n  position: absolute;\r\n  height: 80%;\r\n  width: 4%;\r\n  left: 92%;\r\n  display: flex;\r\n  max-height: 25px;\r\n}\r\n\r\n.imgCardTitleMin:hover {\r\n  background-color: #f1f1f127;\r\n}\r\n\r\n.cardTitleAlert {\r\n  /* background: linear-gradient( #4d0000, #8e0000); */\r\n  /* background: linear-gradient( #6c0101, #8e0000); */\r\n  /* background:var(--red-alert); */\r\n  background: var(--third-color);\r\n  /* background-color: rgba(13, 13, 13, 0.45); */\r\n}\r\n\r\n.cardTitleAlertWhite {\r\n  /* background: linear-gradient( #4d0000, #8e0000); */\r\n  /* background: linear-gradient( #6c0101, #8e0000); */\r\n  background: linear-gradient(#6c0101f6, #8e0000d8);\r\n}\r\n\r\n.menuAlertTabla {\r\n  /* padding: 1%; */\r\n  /* height: 95%; */\r\n  height: calc(100% - 30px);\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.TableHeader {\r\n  height: 10%;\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: rgba(13, 13, 13, 0.45);\r\n  /* background: var(--third-color); */\r\n  max-height: 25px;\r\n}\r\n\r\n.TableBody {\r\n  height: 82%;\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* background-color: rgba(82, 82, 82, 0.347); */\r\n  /* background-color: rgba(70, 0, 0, 0.34); */\r\n  /* background-color: rgba(255, 179, 179, 0.5); */\r\n  overflow-y: scroll;\r\n  scrollbar-width: thin;\r\n\r\n}\r\n\r\n.headerCell:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.headerCell {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  width: 15%;\r\n  /* border-left: 1px solid white; */\r\n  color: white;\r\n  /* font-weight: bold; */\r\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n}\r\n\r\n.txtHeaderCell {\r\n  /* font-weight: unset; */\r\n  font-size: var(--font-size-xSmall);\r\n  letter-spacing: 1px;\r\n  color: var(--white-color) !important;\r\n\r\n}\r\n\r\n.imgCardTitle {\r\n  position: absolute;\r\n  height: 10%;\r\n  width: 10%;\r\n  left: 90%;\r\n  display: flex;\r\n  max-height: 25px;\r\n}\r\n\r\n.imgContent {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.mapboxgl-control-container {\r\n  display: none !important;\r\n}\r\n\r\n.expandLogo {\r\n  position: relative;\r\n  height: 80%;\r\n}\r\n\r\n.expandLogo:hover {\r\n  height: 90%;\r\n  cursor: pointer;\r\n}\r\n\r\n/***************************MODAL***********************************/\r\n.ReactModal__Overlay {\r\n  background-color: #0d0d0de5 !important;\r\n  z-index: 200;\r\n}\r\n\r\n.ReactModal__Content {\r\n  padding: unset !important;\r\n  border: 1px solid #f0f8ff91 !important;\r\n  border-radius: 10px !important;\r\n  background-color: var(--white-color) !important;\r\n  /* background-color: #11121be3 !important; */\r\n}\r\n\r\n/************************************************************************ ESTILOS DE SCROLL BAR**************************************************/\r\n/********************   chrome  *********************/\r\n/* Estilo del scrollbar */\r\n.TableBody::-webkit-scrollbar {\r\n  width: 10px;\r\n  /* Ancho del scrollbar */\r\n}\r\n\r\n/* Estilo del thumb (la barra deslizante) */\r\n.TableBody::-webkit-scrollbar-thumb {\r\n  background-color: #ffffff;\r\n  /* Color del thumb */\r\n  border-radius: 5px;\r\n  /* Borde redondeado del thumb */\r\n}\r\n\r\n/* Estilo del thumb al pasar el cursor sobre él */\r\n.TableBody::-webkit-scrollbar-thumb:hover {\r\n  background-color: #ffffff;\r\n  /* Color del thumb al pasar el cursor */\r\n}\r\n\r\n/* Estilo de la pista (el área donde se desplaza el thumb) */\r\n.TableBody::-webkit-scrollbar-track {\r\n  background-color: #f1f1f100;\r\n  /* Color de la pista */\r\n}\r\n\r\n/********************   firefox  *********************/\r\n/* Estilo del thumb (la barra deslizante) */\r\n.TableBody::-moz-scrollbar-thumb {\r\n  background-color: #d51111;\r\n  /* Color del thumb */\r\n  border-radius: 5px;\r\n  /* Borde redondeado del thumb */\r\n}\r\n\r\n/* Estilo del thumb al pasar el cursor sobre él */\r\n.TableBody::-moz-scrollbar-thumb:hover {\r\n  background-color: #e20e0e;\r\n  /* Color del thumb al pasar el cursor */\r\n}\r\n\r\n/* Estilo de la pista (el área donde se desplaza el thumb) */\r\n.TableBody::-moz-scrollbar-track {\r\n  background-color: #f1f1f1;\r\n  /* Color de la pista */\r\n}\r\n\r\n.map-container {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n/************************Horizontal Movil*************************/\r\n@media (min-width: 500px) and (max-width: 900px) {}\r\n\r\n/************************Movil*************************/\r\n@media (max-width: 500px) {\r\n  .menuAlertTabla {\r\n    width: 300%;\r\n  }\r\n\r\n  .card .menuAlertTabla {\r\n    width: 100%;\r\n  }\r\n\r\n  .menuAlertTitle {\r\n    width: 300%;\r\n  }\r\n\r\n  .imgCardTitleMin.expand {\r\n    left: 292%;\r\n  }\r\n\r\n  .imgCardTitleMin.log {\r\n    left: 280% !important;\r\n  }\r\n\r\n  .cont-menu-eventos {\r\n    width: 120% !important;\r\n  }\r\n\r\n  .card .cont-menu-eventos {\r\n    width: 40% !important;\r\n  }\r\n\r\n  .card .imgCardTitleMin.log {\r\n    left: 80% !important;\r\n  }\r\n\r\n  .card .imgCardTitleMin.expand {\r\n    left: 92%;\r\n  }\r\n\r\n  .compactSelector {\r\n    height: 100% !important;\r\n  }\r\n\r\n  .labelSelector {\r\n    top: 0% !important;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
